import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Button from "./Button";

/**
 * BackButton
 * - Reusable back navigation control.
 * - mode:
 *   - 'overlay': circular icon button suited for image headers/overlays
 *   - 'inline': standard button using shared Button styles with label
 */
export default function BackButton({
  onClick,
  label = "Back",
  mode = "inline",
  className = "",
  title,
}) {
  const navigate = useNavigate();
  const handle = () => (onClick ? onClick() : navigate(-1));

  if (mode === "overlay") {
    return (
      <button
        type="button"
        onClick={handle}
        aria-label={label}
        title={title || label}
        className={`w-9 h-9 rounded-lg bg-white/90 backdrop-blur flex items-center justify-center border border-white/70 shadow active:scale-95 ${className}`}
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
    );
  }

  return (
    <Button variant="secondary" className={className} onClick={handle}>
      <span className="inline-flex items-center gap-1">
        <ChevronLeft className="w-4 h-4" />
      </span>
    </Button>
  );
}
